/**
 * Shell classes for a full-detail right sheet (the tablero lead drawer and the
 * solicitud drawer). These are read-all-day desktop work surfaces, so they run
 * much wider than a stock shadcn sheet — `sm:max-w-none` drops the `sm:max-w-sm`
 * cap baked into `sheetVariants`. Both drawers import this instead of repeating
 * the string so they can never drift to different widths.
 */
export const DETAIL_SHEET_CLASS = "w-full p-0 sm:max-w-none md:w-[70%] lg:w-[75%]";
